import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cheeta-logo-orange.svg'


const _withScopeId = n => (_pushScopeId("data-v-264ad4cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  src: _imports_0,
  alt: "logo"
}
const _hoisted_4 = { class: "product-title" }
const _hoisted_5 = { class: "product-name" }
const _hoisted_6 = { class: "company-name" }
const _hoisted_7 = { class: "nav-bar" }
const _hoisted_8 = { class: "nav-bar-item bordered" }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-shopping-cart" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "logo",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogoClick && _ctx.handleLogoClick(...args)))
    }, [
      (_ctx.companyInfo.logo)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.companyInfo.logo,
            alt: "logo"
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("img", _hoisted_3))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.getCategoryName), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.companyInfo.name), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("a", {
          href: `${_ctx.baseUrl}/DYO_FAQ.pdf`,
          target: "_blank"
        }, "FAQs", 8, _hoisted_9)
      ]),
      _createElementVNode("div", {
        class: "nav-bar-item",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'cart' })))
      }, [
        _hoisted_10,
        _createTextVNode(" CART ")
      ])
    ])
  ]))
}